import { useEffect } from 'react';
import { useNodeId, useUpdateNodeInternals } from '@xyflow/react';

/** Tells the canvas a card's ports moved or changed, so wires attach to where the rows are now. */
export const usePortsChanged = (ports: string): void => {
	const nodeId = useNodeId();
	const update = useUpdateNodeInternals();
	useEffect(() => {
		if (nodeId) update(nodeId);
	}, [nodeId, ports, update]);
};
